var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("grey--text text-xs-" + _vm.align)},[_c('div',{staticClass:"grey--text text--darken-1 body-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v("\n  "+_vm._s(_vm.value || '-')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }